import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import FeatureCards from "./components/FeatureCards";
import ArticleCenter from "./components/ArticleCenter";
import CtaSection from "./components/CtaSection";
import TestimonialSection from "./components/TestimonialSection";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://acbuyspreadsheet.biz";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "name": "ACBuySpreadsheet",
      "url": siteUrl,
      "description": "Smart buying and order tracking spreadsheet system for efficient purchasing workflow optimization.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${siteUrl}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "Organization",
      "name": "ACBuySpreadsheet",
      "url": siteUrl,
      "description": "Spreadsheet-based buying and order tracking system for optimized purchasing workflows across 14 product categories."
    }
  ]
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeatureCards />
        <ArticleCenter />
        <CtaSection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}